/**
 * Public error class for the POLST widget. POL-581 will expand usage
 * to wrap fetch failures; this ticket only defines the shape so the
 * scaffold exports match the documented public surface.
 */
export class PolstApiError extends Error {
  public readonly code: string;
  public readonly status: number;

  constructor(code: string, message: string, status = 0) {
    super(message);
    this.name = "PolstApiError";
    this.code = code;
    this.status = status;
    // Restore prototype chain when transpiled down to ES5.
    Object.setPrototypeOf(this, PolstApiError.prototype);
  }
}
